import { Location } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BaseComponent } from '../../core/components';
import { IPagedResults } from '../../core/interfaces';
import { AccountEmailTemplateModel } from '../../models';
import { EmailService } from '../../services';
@Component({
    selector: 'app-account-email-template',
    templateUrl: './account-email-template.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class AccountEmailTemplateListComponent extends BaseComponent implements OnInit {
    public showSpinner: boolean = false;
    public totalItems: number = 10;
    public model: any;
    public isSystem: any;
    public isAdminOrUserEditor: boolean = false;
    public accountId: any;
    constructor(
        private elem: ElementRef,
        private toastr: ToastsManager,
        private emailService: EmailService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location) {
        super(router);
    }

    packageData: Subject<any> = new Subject<any[]>();
    public ngOnInit(): void {
        let currentLoggedUser = super.currentLoggedUser();
        this.model = new AccountEmailTemplateModel();
        this.accountId = currentLoggedUser.accountId;
        this.loadData();
    }

    public loadData(id?: number): void {
        this.showSpinner = true;
        this.emailService.getGetAllAccountEmailTemplateList(id ? id : this.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: IPagedResults<any>) => {
                let data = response.Data;
                this.packageData.next(data);
                this.totalItems = response.Data.length;
            });
    }

    public toggleEditor(e, item) {
        let viewElement = this.elem.nativeElement.querySelector('#view-' + item.EmailTemplateId);
        let element = this.elem.nativeElement.querySelector('#editor-' + item.EmailTemplateId);
        //if(e.checked) {
        element.style.display = '';
        viewElement.style.display = 'none';
        //subject.innerHTML = '';
        //body.innerHTML = '';
        this.model = item;
        //}
        // else {
        //     element.style.display = 'none';
        //     viewElement.style.display = 'block';

        //     //subject.innerHTML = item.Subject;
        //     //body.innerHTML = item.Body;
        // }
    }

    public emailTemplateViewMode(id) {
        let element = this.elem.nativeElement.querySelector('#editor-' + id);
        element.style.display = 'none';
    }

    public closeEmailEditor(id) {
        this.emailTemplateViewMode(id)
        this.ngOnInit();
    }

    public toggleIsSystem(e, item) {
        this.model.IsSystem = e.checked;
        this.isSystem = e.checked;
        this.toggleEditor(e, item);
    }

    public saveChanges(item) {
        this.showSpinner = true;
        this.model.IsSystem = this.isSystem;
        this.model.AccountId = this.accountId;
        this.model.EmailTemplateId = item.EmailTemplateId;
        this.emailService.saveAccountEmailTemplate(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                if (response.ErrorCode) {
                    this.toastr.error(response.Message, "Error");
                }
                this.closeEmailEditor(this.model.EmailTemplateId)
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/email/account-email-template.component.ts